import camelcase from 'camelcase-keys';
import decamelize from 'decamelize-keys';

const DECAMELIZE_OVERRIDES: Record<string, string> = {
  fortune500_us_rank: 'fortune_500_us_rank',
  fortune500_europe_rank: 'fortune_500_europe_rank',
  fortune500_global_rank: 'fortune_500_global_rank',
};

function applyDecamelizeOverrides(data: unknown): unknown {
  if (Array.isArray(data)) {
    return data.map(applyDecamelizeOverrides);
  }

  if (data !== null && typeof data === 'object') {
    const result: Record<string, unknown> = {};

    for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
      const newKey = DECAMELIZE_OVERRIDES[key] ?? key;
      result[newKey] = applyDecamelizeOverrides(value);
    }

    return result;
  }

  return data;
}

export const camelcaseKeys = (data: Record<string, unknown>) => camelcase(data, { deep: true });
export const decamelizeKeys = (data: Record<string, unknown>) =>
  applyDecamelizeOverrides(decamelize(data, { deep: true })) as Record<string, unknown>;
